import React from 'react'
import {
    Link, Route
} from 'react-router-dom'

import { Typography, Grid, Card } from "@material-ui/core";
import { makeStyles, useTheme } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { useHistory } from 'react-router-dom'

import SettingsOne from './Components/SettingsOne'
import SettingsTwo from './Components/SettingsTwo'


const useStyles = makeStyles(theme => ({

    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '0px 6px'
    },

    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
    cardDiv: {
        padding: 6
    }

}));
export default function Settings({ match }) {
    const classes = useStyles();
    const history = useHistory();

    const redirectTo = (val) => {
        history.push(val)
    }

    return (
        <div className={classes.root}>


            <div className={classes.titleDiv}>
                <Typography variant="h2">Settings (Master)</Typography>
            </div>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>


                    <ButtonGroup color="primary" aria-label="outlined primary button group">
                        <Button onClick={() => { redirectTo('/settings/settings1') }} >settings1</Button>
                        <Button onClick={() => { redirectTo('/settings/settings2') }}>settings2</Button>

                    </ButtonGroup>

                    {/* <ul> 
                            <li><Link to="/settings/settings1"> Settings1</Link></li>
                            <li><Link to="/settings/settings2"> Settings2</Link></li>
                        </ul> */}

                    <Card className={classes.cardDiv}>
                        <Typography variant="h5">
                            Below are nested within settings page, routed along with settings Title & links
                </Typography>

                        <Route path='/settings/settings1' component={SettingsOne} />
                        <Route path='/settings/settings2' component={SettingsTwo} />
                    </Card>

                </Grid>
            </Grid>


        </div>
    )
}
